<template>

    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content">
                <div  class="custom-popup">
                    <div class="popup-content">
                        <div class="icon" :style="{ color: iconColor }">
                            <!-- Show image icon if iconSrc is provided, otherwise use the icon component -->
                            <img v-if="iconSrc" :src="iconSrc" alt="icon" class="popup-icon-image" />
                            <component v-else :is="icon" />
                        </div>
                        <div class="popup-title" v-html="title"></div>
                        <div class="popup-message" v-html="content"></div>
                        <div class="popup-actions">
                            <div @click="handleCancel" class="cancel-button" v-if="cancelText!=null && cancelText != 'null' ">{{ cancelText }}</div>
                            <div :class="confirmButtonType == 'error'? 'error-button': 'confirm-button'" @click="handleConfirm">{{ confirmText }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            visible: Boolean,
            icon: Object,
            iconSrc: String, // New prop to accept image source
            iconColor: String,
            title: String,
            content: String,
            cancelText: String,
            confirmText: String,
            confirmButtonType: String,
            confirmAction: Function,
            cancelAction: Function,
            autoClose: {
                type: Boolean, default: false
            }
        },

        data() {
            return {
                isVisible: this.visible, // Local visibility state
                autoCloseTime: 2000, 
            };
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes

                if (newVal && this.autoClose) {
                    this.startAutoCloseTimer();
                }
            },
        },

        methods: {
            handleCancel() {
               
                if(this.cancelAction){
                    this.cancelAction();
                }
                this.isVisible = false;
                this.$emit('cancel');
            },
            handleConfirm() {
                if (this.confirmAction) {
                    this.confirmAction();
                }
                this.isVisible = false;
                this.$emit('cancel');
            },

            startAutoCloseTimer() {
                setTimeout(() => {              
                    if(this.isVisible){
                        this.handleConfirm(); // Emit cancel when auto-closed
                    }     
                  
                    this.isVisible = false;
                }, this.autoCloseTime);
            },

        },
    };
</script>

<style scoped>

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #00000088;
        z-index: 99999;
    }

    .modal-content {
        text-align: center;
        height:fit-content;    
        width: fit-content;
        max-width: 480px;
        min-width: 320px;
        margin: auto 16px;
        overflow: hidden;
    }

    .popup-content {
        text-align: center;
        padding: 16px; 
        background-color:white;
        border-radius: 8px;
    }

    .icon {
        margin-bottom: 1rem;
        font-size: 1rem;
    }

    .popup-title {
        font-size: 1rem;
        font-weight: bold;
        margin: 0;
    }

    .popup-message {
        font-size: .8rem;
        margin: 0.5rem 0 1rem;
        color:gray;
    }

    .popup-buttons {
        display: flex;
        justify-content: center;
        gap: 1rem;
    }

    
    .popup-actions{display:flex; gap: 16px; justify-content:center;}

    /* Basic button styles */
        .popup-actions div {           
            border: none;
            min-width: 98px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
        }

    /* Cancel Button */
    .cancel-button {
        background-color: #e0e0e0; /* light gray */
        color: #555; /* dark gray */
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
        margin-right: 8px;
    }

        .cancel-button:hover {
            background-color: #cccccc;
        }

    /* Confirm Button (Success) */
    .confirm-button {
        background-color: #198754; /* green */
        color: white;
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

        .confirm-button:hover {
            background-color: #43a047;
        }

    /* Confirm Button (Error) */
    .error-button {
        background-color: #f34546; /* red */
        color: white;
        padding: 8px 24px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

        .error-button:hover {
            background-color: #e53935;
        }

    .popup-icon-image {
        width: 40px; /* Adjust as needed */
        height: 40px;
        /* Other styles if needed */
    }
</style>
